import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
import { mdiBackupRestore } from "@mdi/js"
import { createContactOrderStep } from "../../../../../../../../api/kehrblatt/contact-orders"
import type { ContactOrderStepActionContext } from "../_logic/contract"
import {
  blockedTargetTooltip,
  computeNextDueAt,
  isRetryableStep,
} from "../_shared/_logic/action-availability"
import type { TableRowAction } from "@kontextwerk/web-sdk/core/layout/table"
export default function buildActions(
  {
    row,
    order,
    step,
    caseId,
    contactOrderId,
    targetContactPointUsable,
    canRetry,
    onReloadContactOrders,
  }: ContactOrderStepActionContext & { canRetry: boolean },
  state: { retrying: boolean },
): TableRowAction[] {
  const retryStep = async () => {
    if (!step || !contactOrderId || state.retrying) return

    state.retrying = true
    try {
      const due_at = computeNextDueAt(order.steps ?? [])
      await createContactOrderStep(caseId, contactOrderId, {
        channel: step.channel as ContactChannel,
        execution_mode: step.execution_mode,
        automatic_delivery_committed: false,
        contact_point_id: step.destination?.contact_point_id ?? null,
        recipient_customer_id: step.recipient_customer_id,
        letter_mode: step.letter_mode,
        postal_contact_point_id: step.postal_contact_point_id,
        delivery_due_at: step.delivery_due_at,
        due_at,
        title: step.title ?? null,
        notes: step.notes ?? null,
        template_key: step.template_key,
        subject_template_override: step.subject_template_override,
        body_template_override: step.body_template_override,
        retries_on_no_answer: step.retries_on_no_answer ?? 1,
      })
      newNotification({
        class: "success",
        html: "Ankündigungsschritt erneut eingeplant.",
      })
      await onReloadContactOrders()
    } catch (err) {
      console.error("contact_order_step_retry_failed", err)
      newNotification({
        class: "error",
        html: "Ankündigungsschritt konnte nicht neu eingeplant werden.",
      })
    } finally {
      state.retrying = false
    }
  }
  const actions: TableRowAction[] = []

  if (canRetry && !row.isFuture && isRetryableStep(row, step)) {
    actions.push({
      id: "action-0",
      label: state.retrying ? "Plant…" : "Retry",
      onClick: () => retryStep(),
      icon: mdiBackupRestore,
      disabled: state.retrying || !targetContactPointUsable,
      tooltip: targetContactPointUsable
        ? "Denselben Schritt erneut am Ende der Sequenz einplanen."
        : blockedTargetTooltip,
      display: "inline",
    })
  }

  return actions
}
